module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400.748ab46.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-brands-400.eot
// module id = TpI3
// module chunks = 0